import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Home, ArrowLeft, Search } from 'lucide-react'

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center gradient-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* 404 Number */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-9xl font-bold text-primary-600 mb-8"
            >
              404
            </motion.div>

            {/* Title */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-3xl lg:text-4xl font-bold text-dark-900 mb-4"
            >
              Página não encontrada
            </motion.h1>

            {/* Description */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="text-xl text-gray-600 mb-8"
            >
              A página que você está procurando não existe ou foi movida. 
              Verifique o endereço ou navegue pelas opções abaixo.
            </motion.p>

            {/* Search Icon Animation */}
            <motion.div
              initial={{ opacity: 0, rotate: -180 }}
              animate={{ opacity: 1, rotate: 0 }}
              transition={{ duration: 1, delay: 0.8 }}
              className="mb-8"
            >
              <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-100 rounded-full">
                <Search className="h-10 w-10 text-primary-600" />
              </div>
            </motion.div>

            {/* Action Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1 }}
              className="flex flex-col sm:flex-row gap-4 justify-center"
            >
              <Link 
                to="/" 
                className="btn-primary inline-flex items-center justify-center"
              >
                <Home className="mr-2 h-4 w-4" />
                Voltar ao Início
              </Link>
              
              <button 
                onClick={() => window.history.back()}
                className="btn-outline inline-flex items-center justify-center"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Voltar
              </button>
            </motion.div>

            {/* Quick Links */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.2 }}
              className="mt-12"
            >
              <p className="text-gray-600 mb-4">Ou navegue para:</p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link 
                  to="/solucoes" 
                  className="text-primary-600 hover:text-primary-700 font-medium transition-colors"
                >
                  Soluções
                </Link>
                <Link 
                  to="/apps" 
                  className="text-primary-600 hover:text-primary-700 font-medium transition-colors"
                >
                  Apps
                </Link>
                <Link 
                  to="/sobre" 
                  className="text-primary-600 hover:text-primary-700 font-medium transition-colors"
                >
                  Sobre
                </Link>
                <Link 
                  to="/contato" 
                  className="text-primary-600 hover:text-primary-700 font-medium transition-colors"
                >
                  Contato
                </Link>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default NotFound
